import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

/**
 * Shared "Actions" dropdown for page headers.
 * - Items are dynamically mapped based on props provided.
 */
const CustomAction = ({
  title = "Action",
  id = "custom-action-dropdown",
  actions = [], // pass array of { label, icon, onClick }
}) => {
  return (
    <Dropdown align="end" className="actions-dropdown">
      <Dropdown.Toggle variant="primary" id={id}>
        {title}
      </Dropdown.Toggle>
      <Dropdown.Menu className="">
        {actions.map(
          ({ label, icon: Icon, onClick }, index) =>
            label && (
              <div className="dropdown-item cursor-pointer" key={index} onClick={onClick}>
                {Icon && <Icon className="me-2" />}
                {label}
              </div>
            )
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomAction;
